import { Component, Prop, Vue } from 'vue-property-decorator'
import DiseaseSection from '~/types/api/disease/DiseaseSection'
import ArrowSvg from '~/assets/svg/arrow-top-right.svg?inline'
import loc from '~/utils/loc'

@Component
export default class DiseaseSectionIconItem extends Vue {
  @Prop({ required: true, type: Object })
  readonly section!: DiseaseSection

  get location () {
    return loc(this.$store, {
      name: 'diseases-section',
      params: {
        section: this.section.code
      }
    })
  }

  render () {
    return (
      <nuxt-link {...{
        props: {
          to: this.location
        },
        class: {
          'disease-section-icon-item': true
        }
      }}>
        <div class="disease-section-icon-item__image-wrapper">
          {this.section.icon &&
          <img class="disease-section-icon-item__image" src={this.section.icon.url} alt={this.section.name}/>
          }
          <div class="disease-section-icon-item__arrow">
            <ArrowSvg/>
          </div>
        </div>
        <div class="disease-section-icon-item__text">
          {this.section.name}
        </div>
      </nuxt-link>
    )
  }
}
